import axios from 'axios'
import { CANCELAR_RESERVAS } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function cancelarReservas (empresaId, motivo, habilitadoZerarValorMultaCancelamento, reservas) {
  const url = `${URL}/reserva/cancelar-reservas`;
  return dispatch => axios.post(url,{ empresaId, motivo, habilitadoZerarValorMultaCancelamento, reservas} , SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: CANCELAR_RESERVAS,
        payload: response
      })
  );
}
